import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { V4LciaScore, FetchV4LciaScoresParams } from './types';

export const lciaScoresQueryKey = ({ uprId, version, system_model, method_id }: FetchV4LciaScoresParams) => [
  'v4LciaScores',
  uprId,
  version,
  system_model,
  method_id,
];

export const fetchLciaScores = async (params: FetchV4LciaScoresParams): Promise<V4LciaScore[]> => {
  const { data } = await api.get(`/web/v4/uprs/${params.uprId}/methods/${params.method_id}`, { params });
  return data;
};

/** Only v4 releases serve this endpoint, so the query stays idle on 3.x. See useV4Dataset. */
const useV4LciaScores = (uprId: string, method_id: string) => {
  const { ver: version, system_model } = useVersionInfo();
  return useQuery<V4LciaScore[], AxiosError>({
    queryKey: lciaScoresQueryKey({ uprId, method_id, version, system_model }),
    queryFn: () => fetchLciaScores({ uprId, method_id, version, system_model }),
    // Without a method the URL would resolve to the methods list endpoint.
    enabled: isV4Release(version) && !!uprId && uprId !== '-1' && !!method_id,
  });
};

export default useV4LciaScores;
